import { supabase } from '../supabaseClient';

export async function fetchFollowingForUser(userId, { limit = 200, offset = 0 } = {}) {
  const { data, error } = await supabase.rpc('get_following_for_user', {
    p_user_id: userId,
    p_limit: limit,
    p_offset: offset,
  });
  if (error) throw error;
  return data ?? [];
}

export async function fetchFollowersForUser(userId, { limit = 200, offset = 0 } = {}) {
  const { data, error } = await supabase.rpc('get_followers_for_user', {
    p_user_id: userId,
    p_limit: limit,
    p_offset: offset,
  });
  if (error) throw error;
  return data ?? [];
}

export async function fetchSuggestedPeople(userId, { limit = 20 } = {}) {
  const { data, error } = await supabase.rpc('get_suggested_people_for_user', {
    p_user_id: userId,
    p_limit: limit,
  });
  if (error) throw error;
  return data ?? [];
}

export async function searchPeopleRanked(userId, query, { limit = 20 } = {}) {
  const trimmed = query.trim();
  if (!trimmed) return [];

  const { data, error } = await supabase.rpc('search_people_ranked', {
    p_user_id: userId,
    p_query: trimmed,
    p_limit: limit,
  });
  if (error) throw error;
  return data ?? [];
}
